var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-fetcher',{attrs:{"fetch-data":_vm.fetch}},[_c('p',[_vm._v("\n\t\tTasks:\n\t\t"),_c('strong',[_vm._v(_vm._s(_vm.displayedSyncTasks.length))])]),_c('v-treeview',{attrs:{"items":_vm.displayedSyncTasks,"open-on-click":true,"dense":""},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
return [(item.isDone)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check")]):(item.isProcessing)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("autorenew")]):_vm._e()]}},{key:"label",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [_vm._v(_vm._s(_vm.getTaskName(item)))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }